import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, vModelRadio as _vModelRadio, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b42c4260"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AdminEvents" }
const _hoisted_2 = { id: "showevents" }
const _hoisted_3 = { class: "display-2 adminHeadline" }
const _hoisted_4 = { class: "tabHeight" }
const _hoisted_5 = { class: "row align--baseline justify--start" }
const _hoisted_6 = { class: "md2 flex ml-4" }
const _hoisted_7 = {
  class: "md3 flex ml-4",
  style: {"display":"flex"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_9 = { class: "md2 flex ml-4" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_12 = {
  class: "va-table va-table--striped eventsTable",
  style: {"width":"100%"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { hidden: "" }, "Id", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Se tilmeldinger", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Handlinger", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = ["id"]
const _hoisted_18 = ["id"]
const _hoisted_19 = ["id"]
const _hoisted_20 = ["id"]
const _hoisted_21 = ["id"]
const _hoisted_22 = ["id"]
const _hoisted_23 = ["id"]
const _hoisted_24 = ["id"]
const _hoisted_25 = ["id"]
const _hoisted_26 = ["id"]
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Tilmeldinger")
const _hoisted_28 = ["id"]
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Vis/Rediger")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_31 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_33 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_34 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_36 = { class: "selectPageSize" }
const _hoisted_37 = { class: "display-4 center mt-2" }
const _hoisted_38 = { class: "layout gutter--xl" }
const _hoisted_39 = { class: "row justify--space-around" }
const _hoisted_40 = { class: "flex" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Tilmeld ny")
const _hoisted_42 = { class: "flex" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Eksporter")
const _hoisted_44 = { class: "va-table responsive" }
const _hoisted_45 = {
  class: "va-table va-table--striped",
  style: {"width":"100%"}
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Navn"),
    /*#__PURE__*/_createElementVNode("th", null, "Licens"),
    /*#__PURE__*/_createElementVNode("th", null, "Klub"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Fjern tilmelding")
  ])
], -1))
const _hoisted_47 = { class: "center" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "display-5 center" }, "Tilføj medlemmer", -1))
const _hoisted_49 = { class: "layout gutter--xl" }
const _hoisted_50 = { class: "row justify--center align--center" }
const _hoisted_51 = { class: "flex" }
const _hoisted_52 = { class: "flex" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Tilføj medlem")
const _hoisted_54 = { class: "row justify--center" }
const _hoisted_55 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_56 = { class: "layout gutter--xl" }
const _hoisted_57 = { class: "row justify--center" }
const _hoisted_58 = { class: "flex" }
const _hoisted_59 = { class: "emphasizedText" }
const _hoisted_60 = { class: "layout gutter--xl" }
const _hoisted_61 = { class: "row justify--center align--center" }
const _hoisted_62 = { class: "flex" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_64 = { class: "flex" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode("Nej")
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layout gutter--xl" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "emphasizedText" }, "Er du sikker på at du vil slette dette arrangement?")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "center" }, "Handlingen kan ikke fortrydes")
    ])
  ])
], -1))
const _hoisted_67 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_68 = /*#__PURE__*/_createTextVNode("Nej")
const _hoisted_69 = { class: "editeventModal" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md12 flex" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "mb-4",
    style: {"font-size":"1.2em"}
  }, "Ændre arrangementets oplysninger")
], -1))
const _hoisted_71 = { class: "row" }
const _hoisted_72 = { class: "md8 flex eventModal" }
const _hoisted_73 = { class: "md4 flex eventModal" }
const _hoisted_74 = { class: "row" }
const _hoisted_75 = { class: "md6 flex eventModal" }
const _hoisted_76 = {
  key: 0,
  class: "md6 flex eventModal"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "invitationlabel" }, "Invitationer", -1))
const _hoisted_78 = { class: "md1 flex" }
const _hoisted_79 = { class: "md8 flex" }
const _hoisted_80 = { class: "md1 flex" }
const _hoisted_81 = ["onClick"]
const _hoisted_82 = { class: "row justify--center" }
const _hoisted_83 = /*#__PURE__*/_createTextVNode("Tilføj invitation")
const _hoisted_84 = { class: "row" }
const _hoisted_85 = { class: "md8 flex eventModal" }
const _hoisted_86 = { class: "md4 flex eventModal" }
const _hoisted_87 = { class: "row" }
const _hoisted_88 = { class: "md6 flex eventModal" }
const _hoisted_89 = { class: "md6 flex eventModal" }
const _hoisted_90 = { class: "row" }
const _hoisted_91 = { class: "md4 flex evnentModal" }
const _hoisted_92 = { class: "md4 flex eventModal" }
const _hoisted_93 = { class: "md4 flex eventModal" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--start" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "flex eventModal mb-4" }, "Kontaktinformation:")
], -1))
const _hoisted_95 = { class: "row" }
const _hoisted_96 = { class: "flex md6" }
const _hoisted_97 = { class: "row" }
const _hoisted_98 = { class: "md6 flex eventModal" }
const _hoisted_99 = { class: "md6 flex eventModal" }
const _hoisted_100 = { class: "row" }
const _hoisted_101 = { class: "md6 flex eventModal" }
const _hoisted_102 = { class: "md6 flex eventModal" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Felter markeret med * kan ikke ændres", -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Felter markeret med ** er ikke obligatoriske", -1))
const _hoisted_105 = /*#__PURE__*/_createTextVNode("Gem")
const _hoisted_106 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_107 = { class: "invitationmodal" }
const _hoisted_108 = { class: "invitationflexbox" }
const _hoisted_109 = { class: "invitationradio" }
const _hoisted_110 = ["id", "value"]
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Upload ny invitation")
], -1))
const _hoisted_112 = { class: "uploadsection mb-4" }
const _hoisted_113 = /*#__PURE__*/_createTextVNode("Upload ny pdf")
const _hoisted_114 = /*#__PURE__*/_createTextVNode("Tilføj valgte invitation")
const _hoisted_115 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_116 = { class: "tabHeight" }
const _hoisted_117 = { id: "newevents" }
const _hoisted_118 = { key: 0 }
const _hoisted_119 = {
  key: 1,
  class: "form"
}
const _hoisted_120 = { key: 0 }
const _hoisted_121 = { class: "eventform-group" }
const _hoisted_122 = { class: "layout gutter--xl" }
const _hoisted_123 = { class: "row" }
const _hoisted_124 = { class: "flex md6" }
const _hoisted_125 = { class: "flex md6" }
const _hoisted_126 = { class: "row" }
const _hoisted_127 = { class: "md6 flex eventModal" }
const _hoisted_128 = {
  key: 0,
  class: "md6 flex eventModal"
}
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "invitationlabel" }, "Invitationer", -1))
const _hoisted_130 = { class: "md1 flex" }
const _hoisted_131 = { class: "md8 flex" }
const _hoisted_132 = { class: "md1 flex" }
const _hoisted_133 = ["onClick"]
const _hoisted_134 = { class: "row justify--center" }
const _hoisted_135 = /*#__PURE__*/_createTextVNode("Tilføj invitation")
const _hoisted_136 = { class: "row" }
const _hoisted_137 = { class: "flex md6" }
const _hoisted_138 = { class: "flex md6" }
const _hoisted_139 = { class: "row" }
const _hoisted_140 = { class: "flex md4" }
const _hoisted_141 = { class: "flex md4" }
const _hoisted_142 = { class: "flex md4" }
const _hoisted_143 = { class: "row" }
const _hoisted_144 = { class: "flex md6" }
const _hoisted_145 = { class: "row" }
const _hoisted_146 = { class: "md6 flex eventModal" }
const _hoisted_147 = { class: "md6 flex eventModal" }
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "* Hvis ikke noget er angivet, er sidste frist arrangementet startsdato", -1))
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "** Feltet er ikke obligatorisk", -1))
const _hoisted_150 = { class: "row justify--center" }
const _hoisted_151 = { class: "flex" }
const _hoisted_152 = /*#__PURE__*/_createTextVNode("Opret arrangement")
const _hoisted_153 = { class: "invitationmodal" }
const _hoisted_154 = { class: "invitationflexbox" }
const _hoisted_155 = { class: "invitationradio" }
const _hoisted_156 = ["id", "value"]
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Upload ny invitation")
], -1))
const _hoisted_158 = { class: "uploadsection mb-4" }
const _hoisted_159 = /*#__PURE__*/_createTextVNode("Upload ny pdf")
const _hoisted_160 = /*#__PURE__*/_createTextVNode("Tilføj valgte invitation")
const _hoisted_161 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_162 = { class: "tabHeight" }
const _hoisted_163 = { class: "editeventtypemain-wrap" }
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_165 = { key: 0 }
const _hoisted_166 = {
  key: 1,
  class: "eventypes_container"
}
const _hoisted_167 = ["id"]
const _hoisted_168 = ["id"]
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Beskrivelse:", -1))
const _hoisted_170 = ["id"]
const _hoisted_171 = /*#__PURE__*/_createTextVNode("Vis/Rediger")
const _hoisted_172 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layout gutter--xl" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "emphasizedText" }, "Er du sikker på at du vil slette arrangement-typen?")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", null, "Handlingen kan ikke fortrydes")
    ])
  ])
], -1))
const _hoisted_174 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_175 = /*#__PURE__*/_createTextVNode("Nej")
const _hoisted_176 = { class: "editeventTypeModal" }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md12 flex" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "mb-4 center",
    style: {"font-size":"1.2em"}
  }, "Ændre arrangement-typens oplysninger")
], -1))
const _hoisted_178 = { class: "row justify--center" }
const _hoisted_179 = { class: "md10 flex eventModal" }
const _hoisted_180 = { class: "row justify--center" }
const _hoisted_181 = { class: "md10 flex eventModal" }
const _hoisted_182 = /*#__PURE__*/_createTextVNode("Gem")
const _hoisted_183 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_184 = { class: "tabHeight" }
const _hoisted_185 = { id: "neweventtypes" }
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_187 = { key: 0 }
const _hoisted_188 = {
  key: 1,
  class: "form"
}
const _hoisted_189 = { key: 0 }
const _hoisted_190 = { class: "eventtypeform-group" }
const _hoisted_191 = { class: "layout gutter--xl" }
const _hoisted_192 = { class: "row justify--center" }
const _hoisted_193 = { class: "flex md10" }
const _hoisted_194 = { class: "row justify--center" }
const _hoisted_195 = { class: "flex md10" }
const _hoisted_196 = { class: "row justify--center" }
const _hoisted_197 = { class: "flex" }
const _hoisted_198 = /*#__PURE__*/_createTextVNode("Opret arrangement-typen")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_tab = _resolveComponent("va-tab")!
  const _component_va_tabs = _resolveComponent("va-tabs")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_va_button_group = _resolveComponent("va-button-group")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_it_drawer = _resolveComponent("it-drawer")!
  const _component_it_modal = _resolveComponent("it-modal")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_va_form = _resolveComponent("va-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.msg), 1),
      _createVNode(_component_va_tabs, {
        class: "adminTabs",
        modelValue: _ctx.tabValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabValue) = $event))
      }, {
        tabs: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Vis og rediger arrangementer', 'Opret nyt arrangement', 'Vis og rediger arrangement-typer', 'Opret ny arrangement-type'], (title) => {
            return _createVNode(_component_va_tab, {
              key: title,
              name: title
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(title), 1)
              ]),
              _: 2
            }, 1032, ["name"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Nulstil kolonner"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_button, {
                  class: "btn",
                  rounded: false,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.columnSort('reset')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, {
                      class: "reset",
                      name: "autorenew"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_va_input, {
              modelValue: _ctx.eventSearchInputValue,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.eventSearchInputValue) = $event)),
              label: "Søg",
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.findEvent()), ["enter"]))
            }, {
              prependInner: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "event" })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_button, {
              size: "small",
              rounded: false,
              class: "btn ml-2",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.findEvent()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "search" }),
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Filtrere efter status",
              placement: "right"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_select, {
                  class: "ml-4",
                  modelValue: _ctx.filterStatusStringValue,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterStatusStringValue) = $event)),
                  options: _ctx.filterStatusStringOptions,
                  bordered: "",
                  style: {"width":"75%"}
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_it_divider),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("table", _hoisted_12, [
                _createElementVNode("tr", null, [
                  _hoisted_13,
                  _createElementVNode("th", {
                    class: "sorting",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.columnSort('titel')))
                  }, "Titel"),
                  _createElementVNode("th", {
                    class: "center sorting",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.columnSort('pris')))
                  }, "Pris"),
                  _createElementVNode("th", {
                    class: "center sorting",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.columnSort('start')))
                  }, "Starttidspunkt"),
                  _createElementVNode("th", {
                    class: "center sorting",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.columnSort('slut')))
                  }, "Sluttidspunkt"),
                  _createElementVNode("th", {
                    class: "sorting",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.columnSort('type')))
                  }, "Type"),
                  _createElementVNode("th", {
                    class: "sorting",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.columnSort('sted')))
                  }, "Sted"),
                  _createElementVNode("th", {
                    class: "sorting",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.columnSort('klub')))
                  }, "Klub"),
                  _hoisted_14,
                  _hoisted_15
                ]),
                _hoisted_16,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: event.id
                  }, [
                    _createElementVNode("td", {
                      id: 'eventstable-row' + (index+1),
                      hidden: ""
                    }, _toDisplayString(event.id), 9, _hoisted_17),
                    _createElementVNode("td", {
                      id: 'eventstable-row' + (index+1)
                    }, _toDisplayString(event.event_titel), 9, _hoisted_18),
                    _createElementVNode("td", {
                      class: "center",
                      id: 'eventstable-row' + (index+1)
                    }, _toDisplayString(event.event_pris), 9, _hoisted_19),
                    _createElementVNode("td", {
                      class: "center",
                      id: 'eventstable-row' + (index+1)
                    }, _toDisplayString((new Date(event.event_start)).toLocaleDateString('da-DK', { hour: 'numeric', minute: 'numeric' })), 9, _hoisted_20),
                    _createElementVNode("td", {
                      class: "center",
                      id: 'eventstable-row' + (index+1)
                    }, _toDisplayString((new Date(event.event_slut)).toLocaleDateString('da-DK', { hour: 'numeric', minute: 'numeric' })), 9, _hoisted_21),
                    _createElementVNode("td", {
                      id: 'eventstable-row' + (index+1)
                    }, _toDisplayString(event?.event_type_id?.event_type_titel), 9, _hoisted_22),
                    _createElementVNode("td", {
                      id: 'eventstable-row' + (index+1)
                    }, _toDisplayString(event.event_sted), 9, _hoisted_23),
                    (event.klubber_id === null || event.klubber_id === '0')
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 0,
                          id: 'eventstable-row' + (index+1)
                        }, "Ingen", 8, _hoisted_24))
                      : (_openBlock(), _createElementBlock("td", {
                          key: 1,
                          id: 'eventstable-row' + (index+1)
                        }, _toDisplayString(event?.klubber_id?.klubber_klubnavn), 9, _hoisted_25)),
                    _createElementVNode("td", {
                      id: 'eventstable-row' + (index+1)
                    }, [
                      _createVNode(_component_va_button, {
                        class: "btn",
                        rounded: false,
                        onClick: ($event: any) => (_ctx.retrieveEventRegistrations(event.id, event.event_titel))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_27
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ], 8, _hoisted_26),
                    _createElementVNode("td", {
                      id: 'eventstable-row' + (index+1)
                    }, [
                      _createVNode(_component_va_button_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_va_button, {
                            class: "btn",
                            color: "info",
                            rounded: false,
                            name: "editevent",
                            onClick: ($event: any) => (_ctx.editEvent(event.id, event.documentId))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_29
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_va_button, {
                            class: "btn status-width",
                            icon: event.event_status ? 'check_box' : 'check_box_outline_blank',
                            color: event.event_status ? 'success' : 'rgb(255, 172, 10)',
                            name: "statusEvent",
                            onClick: ($event: any) => (_ctx.statusEvent(event.id, event.documentId))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(event.event_status ? 'Udgivet' : 'Kladde'), 1)
                            ]),
                            _: 2
                          }, 1032, ["icon", "color", "onClick"]),
                          _createVNode(_component_va_button, {
                            class: "btn",
                            color: "danger",
                            rounded: false,
                            name: "deleteevent",
                            onClick: ($event: any) => (_ctx.deleteEventWarning(event.id, event.documentId))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_30
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ], 8, _hoisted_28)
                  ]))
                }), 128))
              ])
            ])),
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_va_button, {
            icon: "first_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.jumpToPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.turnToNewPage(-5)))
          }),
          _createVNode(_component_va_button, {
            icon: "chevron_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.turnToNewPage(-1)))
          }),
          _hoisted_32,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.currentPage) = $event)),
            type: "number",
            onKeyup: _cache[17] || (_cache[17] = _withKeys(($event: any) => (_ctx.jumpToPage(this.currentPage)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.currentPage]
          ]),
          (_ctx.totalNumberOfPages === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_33, " af " + _toDisplayString(_ctx.totalNumberOfPages+1), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_34, " af " + _toDisplayString(_ctx.totalNumberOfPages), 1)),
          _createVNode(_component_va_button, {
            icon: "chevron_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.turnToNewPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.turnToNewPage(5)))
          }),
          _createVNode(_component_va_button, {
            icon: "last_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.jumpToPage(this.totalNumberOfPages)))
          }),
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_va_select, {
              class: "mr-2",
              modelValue: _ctx.pageSizeValueString,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.pageSizeValueString) = $event)),
              options: _ctx.pageSizeOptions,
              bordered: ""
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_it_drawer, {
          modelValue: _ctx.eventRegistrationDrawer,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.eventRegistrationDrawer) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("h4", _hoisted_37, "Tilmeldinger til " + _toDisplayString(_ctx.eventRegistrationTitle), 1),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_va_button, {
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.addMemberToEventModal = true))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_41
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_va_button, {
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.exportRegistrationToExcel()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_43
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createVNode(_component_va_divider),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("table", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventRegistration, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(_ctx.getMemberNamesFromId(item?.medlem_id?.id)), 1),
                      _createElementVNode("td", null, _toDisplayString(item?.medlem_id?.medlem_licens), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.getClubNameFromId(item?.medlem_id?.id)), 1),
                      _createElementVNode("td", _hoisted_47, [
                        _createVNode(_component_va_icon, {
                          name: "delete_forever",
                          class: "hoverEffect",
                          onClick: ($event: any) => (_ctx.removeMemberWarning(item.id, item?.medlem_id?.id)),
                          color: "danger"
                        }, null, 8, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_it_modal, {
          modelValue: _ctx.addMemberToEventModal,
          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.addMemberToEventModal) = $event))
        }, {
          header: _withCtx(() => [
            _hoisted_48
          ]),
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_component_va_select, {
                    label: "Medlem",
                    options: _ctx.findMemberOptions,
                    modelValue: _ctx.findMemberValue,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.findMemberValue) = $event)),
                    "text-by": (v) => v.name,
                    "track-by": (v) => v.id,
                    onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.clearInput())),
                    onKeydown: _cache[27] || (_cache[27] = event => { _ctx.backSpace = event.key }),
                    onKeypress: _cache[28] || (_cache[28] = e => { _ctx.memberSearchInputString += e.key}),
                    bordered: "",
                    searchable: ""
                  }, null, 8, ["options", "modelValue", "text-by", "track-by"])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_component_va_button, {
                    color: "success",
                    size: "small",
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.addMemberToEvent()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_53
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          actions: _withCtx(() => [
            _createElementVNode("div", _hoisted_54, [
              _createVNode(_component_va_button, {
                onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.addMemberToEventModal = false)),
                color: "secondary"
              }, {
                default: _withCtx(() => [
                  _hoisted_55
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_it_modal, {
          modelValue: _ctx.removeMemberWarningModal,
          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.removeMemberWarningModal) = $event))
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("p", _hoisted_59, "Er du sikker på at du at " + _toDisplayString(_ctx.getMemberNamesFromId(this.eventMemberId)) + " ikke skal med", 1)
                ])
              ])
            ])
          ]),
          actions: _withCtx(() => [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _createVNode(_component_va_button, {
                    class: "btn",
                    color: "danger",
                    onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.deleteEventRegistration(this.eventRegistrationId), _ctx.$Message.success({ text: 'Tilmeldingen er blevet fjernet' })))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_63
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createVNode(_component_va_button, {
                    class: "btn",
                    color: "secondary",
                    onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.removeMemberWarningModal = false, _ctx.$Message.warning({ text: 'Annulleret' })))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_65
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.deleteEventWarningModal,
          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.deleteEventWarningModal) = $event)),
          "hide-default-actions": "",
          "overlay-opacity": "0.5"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn deletebuttonmargin",
              color: "danger",
              onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.deleteEvent(this.deleteEventDocumentId), _ctx.$Message.success({ text: 'Arrangementet er blevet slettet' })))
            }, {
              default: _withCtx(() => [
                _hoisted_67
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn deletebuttonmargin",
              color: "secondary",
              onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.deleteEventWarningModal = false, _ctx.$Message.warning({ text: 'Annulleret' })))
            }, {
              default: _withCtx(() => [
                _hoisted_68
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_66
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editEventModal,
          "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.editEventModal) = $event)),
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "success",
              onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.updateEvent()))
            }, {
              default: _withCtx(() => [
                _hoisted_105
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "secondary",
              onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), (_ctx.editEventModal = false), _ctx.cancelEventEdit()))
            }, {
              default: _withCtx(() => [
                _hoisted_106
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_69, [
              _hoisted_70,
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _createVNode(_component_va_input, {
                    class: "mb-4",
                    type: "text",
                    modelValue: _ctx.eventData.eventTitle,
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.eventData.eventTitle) = $event)),
                    label: "Titel",
                    placeholder: "Titeltekst",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _createVNode(_component_va_select, {
                    label: "Arrangement-type",
                    class: "mb-4",
                    modelValue: _ctx.eventTypeTitleValue,
                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.eventTypeTitleValue) = $event)),
                    options: _ctx.eventTypeTitleOptions,
                    bordered: ""
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("div", _hoisted_75, [
                  _createVNode(_component_va_input, {
                    class: "mb-4",
                    type: "textarea",
                    modelValue: _ctx.eventData.eventDescription,
                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.eventData.eventDescription) = $event)),
                    label: "Beskrivelse",
                    placeholder: "Tekst",
                    "min-rows": 5,
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                ((_ctx.eventData?.eventInvitation?.length - 1 > 0 || _ctx.eventData.eventInvitation !== null))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                      _hoisted_77,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventData.eventInvitation, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id,
                          class: "row invitationrow align-self--baseline mb-4"
                        }, [
                          _createElementVNode("div", _hoisted_78, _toDisplayString(index+1 + '.'), 1),
                          _createElementVNode("div", _hoisted_79, _toDisplayString(item.name), 1),
                          _createElementVNode("div", _hoisted_80, [
                            _createElementVNode("button", {
                              class: "eventbutton",
                              onClick: ($event: any) => (_ctx.removeInvitation(index))
                            }, [
                              _createVNode(_component_va_icon, {
                                name: "clear",
                                color: "danger"
                              })
                            ], 8, _hoisted_81)
                          ])
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_82, [
                        _createVNode(_component_va_button, {
                          onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.addInvitation('edit'))),
                          color: "success"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_83
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("div", _hoisted_85, [
                  _createVNode(_component_va_input, {
                    class: "mb-4",
                    type: "text",
                    modelValue: _ctx.eventData.eventLocation,
                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.eventData.eventLocation) = $event)),
                    label: "Sted",
                    placeholder: "Sted",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_86, [
                  _createVNode(_component_va_input, {
                    class: "mb-4 center",
                    type: "number",
                    modelValue: _ctx.eventData.eventPrice,
                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.eventData.eventPrice) = $event)),
                    label: "Pris",
                    placeholder: "Beløb",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("div", _hoisted_88, [
                  _createVNode(_component_va_select, {
                    class: "mb-4 inputSizing",
                    label: "Tilknyt produkt",
                    modelValue: _ctx.productValue,
                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.productValue) = $event)),
                    options: _ctx.productOptions,
                    "text-by": "name",
                    searchable: "",
                    "prevent-overflow": "",
                    bordered: ""
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_89, [
                  _createVNode(_component_va_select, {
                    class: "mb-4 inputSizing",
                    label: "Tilknyt produktgruppe",
                    modelValue: _ctx.productTypeValue,
                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.productTypeValue) = $event)),
                    options: _ctx.productTypeOptions,
                    "text-by": "name",
                    searchable: "",
                    "prevent-overflow": "",
                    bordered: ""
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_90, [
                _createElementVNode("div", _hoisted_91, [
                  _createVNode(_component_va_input, {
                    class: "mb-4",
                    type: "date",
                    modelValue: _ctx.eventData.registrationDeadline,
                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.eventData.registrationDeadline) = $event)),
                    label: "Sidste tilmeldingsfrist",
                    placeholder: "Dato",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_92, [
                  _createVNode(_component_va_input, {
                    class: "mb-4",
                    type: "datetime-local",
                    modelValue: _ctx.eventData.eventStart,
                    "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.eventData.eventStart) = $event)),
                    label: "Starttidspunkt",
                    placeholder: "Dato",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_93, [
                  _createVNode(_component_va_input, {
                    class: "mb-4",
                    type: "datetime-local",
                    modelValue: _ctx.eventData.eventEnd,
                    "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.eventData.eventEnd) = $event)),
                    label: "Sluttidspunkt",
                    placeholder: "Dato",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _hoisted_94,
              _createElementVNode("div", _hoisted_95, [
                _createElementVNode("div", _hoisted_96, [
                  _createVNode(_component_va_select, {
                    class: "mb-4 item",
                    label: "Arrangørklub",
                    modelValue: _ctx.eventClubsNameValue,
                    "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.eventClubsNameValue) = $event)),
                    options: _ctx.eventClubsNameOptions,
                    "text-by": "name",
                    searchable: "",
                    bordered: ""
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_97, [
                _createElementVNode("div", _hoisted_98, [
                  (_ctx.eventData.clubTelefon === '')
                    ? (_openBlock(), _createBlock(_component_va_input, {
                        key: 0,
                        class: "mb-4 center",
                        type: "text",
                        label: "Telefon *",
                        placeholder: "Ingen",
                        readonly: "",
                        bordered: ""
                      }))
                    : (_openBlock(), _createBlock(_component_va_input, {
                        key: 1,
                        class: "mb-4",
                        modelValue: _ctx.eventData.clubTelefon,
                        "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.eventData.clubTelefon) = $event)),
                        type: "text",
                        label: "Telefon *",
                        readonly: "",
                        bordered: ""
                      }, null, 8, ["modelValue"]))
                ]),
                _createElementVNode("div", _hoisted_99, [
                  (_ctx.eventData.clubEmail === '')
                    ? (_openBlock(), _createBlock(_component_va_input, {
                        key: 0,
                        class: "mb-4 center",
                        type: "text",
                        label: "Email *",
                        placeholder: "Ingen",
                        readonly: "",
                        bordered: ""
                      }))
                    : (_openBlock(), _createBlock(_component_va_input, {
                        key: 1,
                        class: "mb-4",
                        modelValue: _ctx.eventData.clubEmail,
                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.eventData.clubEmail) = $event)),
                        type: "text",
                        label: "Email *",
                        readonly: "",
                        bordered: ""
                      }, null, 8, ["modelValue"]))
                ])
              ]),
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("div", _hoisted_101, [
                  _createVNode(_component_va_input, {
                    class: "mb-4",
                    modelValue: _ctx.eventData.extraContactTelephone,
                    "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.eventData.extraContactTelephone) = $event)),
                    type: "text",
                    label: "Tilmelding Telefonnummer **",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_102, [
                  _createVNode(_component_va_input, {
                    class: "mb-4",
                    modelValue: _ctx.eventData.extraContactEmail,
                    "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.eventData.extraContactEmail) = $event)),
                    type: "text",
                    label: "Tilmelding Email **",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _hoisted_103,
              _hoisted_104
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.addInvitationModal,
          "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.addInvitationModal) = $event)),
          size: "large",
          "overlay-opacity": "0.5",
          "hide-default-actions": "",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "mr-4",
              color: "success",
              onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.useSelectedInvitation('edit')))
            }, {
              default: _withCtx(() => [
                _hoisted_114
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              color: "secondary",
              onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.cancelAddInvitation('edit')))
            }, {
              default: _withCtx(() => [
                _hoisted_115
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_107, [
              _createElementVNode("div", _hoisted_108, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medias, (media, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "invitationcontainer",
                    key: media.id
                  }, [
                    _createElementVNode("label", _hoisted_109, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.selectedEventInvitation) = $event)),
                        type: "radio",
                        color: "success",
                        id: index,
                        name: "choosenInvitation",
                        value: media
                      }, null, 8, _hoisted_110), [
                        [_vModelRadio, _ctx.selectedEventInvitation]
                      ]),
                      _createTextVNode(" " + _toDisplayString(' ' + media.name), 1)
                    ])
                  ]))
                }), 128))
              ]),
              _createVNode(_component_va_divider),
              _hoisted_111,
              _createElementVNode("div", _hoisted_112, [
                _createElementVNode("input", {
                  class: "mb-4",
                  type: "file",
                  onChange: _cache[58] || (_cache[58] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
                }, null, 32),
                _createVNode(_component_va_button, {
                  class: "btn",
                  onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.onUpload()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_113
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis og rediger arrangementer']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_116, [
        _createElementVNode("div", _hoisted_117, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_118, _toDisplayString(_ctx.error), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_119, [
                (!_ctx.submitted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                      _createElementVNode("div", _hoisted_121, [
                        _createVNode(_component_va_form, {
                          ref: "form",
                          id: "neweventform",
                          onSubmit: _ctx.handleSubmit
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_122, [
                              _createElementVNode("div", _hoisted_123, [
                                _createElementVNode("div", _hoisted_124, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item",
                                    modelValue: _ctx.eventData.eventTitle,
                                    "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.eventData.eventTitle) = $event)),
                                    type: "text",
                                    label: "Titel",
                                    rules: [(eventTitle) => _ctx.eventData.eventTitle.length > 1 || 'Der mangler en titel'],
                                    placeholder: "Titeltekst",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_125, [
                                  _createVNode(_component_va_select, {
                                    label: "Arrangement-type",
                                    class: "mb-4 item",
                                    modelValue: _ctx.eventTypeTitleValue,
                                    "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.eventTypeTitleValue) = $event)),
                                    options: _ctx.eventTypeTitleOptions,
                                    bordered: ""
                                  }, null, 8, ["modelValue", "options"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_126, [
                                _createElementVNode("div", _hoisted_127, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4",
                                    type: "textarea",
                                    modelValue: _ctx.eventData.eventDescription,
                                    "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.eventData.eventDescription) = $event)),
                                    label: "Beskrivelse",
                                    placeholder: "Tekst",
                                    "min-rows": 5,
                                    bordered: ""
                                  }, null, 8, ["modelValue"])
                                ]),
                                ((_ctx.eventData?.eventInvitation?.length - 1 > 0 || _ctx.eventData.eventInvitation !== null))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                      _hoisted_129,
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventData.eventInvitation, (item, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: item.id,
                                          class: "row invitationrow align-self--baseline mb-4"
                                        }, [
                                          _createElementVNode("div", _hoisted_130, _toDisplayString(index+1 + '.'), 1),
                                          _createElementVNode("div", _hoisted_131, _toDisplayString(item.name), 1),
                                          _createElementVNode("div", _hoisted_132, [
                                            _createElementVNode("button", {
                                              class: "eventbutton",
                                              onClick: ($event: any) => (_ctx.removeInvitation(index))
                                            }, [
                                              _createVNode(_component_va_icon, {
                                                name: "clear",
                                                color: "danger"
                                              })
                                            ], 8, _hoisted_133)
                                          ])
                                        ]))
                                      }), 128)),
                                      _createElementVNode("div", _hoisted_134, [
                                        _createVNode(_component_va_button, {
                                          onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.addInvitation('create'))),
                                          color: "success"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_135
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_136, [
                                _createElementVNode("div", _hoisted_137, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item",
                                    type: "text",
                                    modelValue: _ctx.eventData.eventLocation,
                                    "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.eventData.eventLocation) = $event)),
                                    label: "Sted",
                                    rules: [(eventLocation) => _ctx.eventData.eventLocation.length > 1 || 'Der mangler en stedsangivelse'],
                                    placeholder: "Sted",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_138, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item",
                                    type: "number",
                                    modelValue: _ctx.eventData.eventPrice,
                                    "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.eventData.eventPrice) = $event)),
                                    label: "Pris",
                                    rules: [(eventPrice) => _ctx.eventData.eventPrice.length > 0 || 'Der mangler en beløbsangivelse'],
                                    placeholder: "Beløb",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_139, [
                                _createElementVNode("div", _hoisted_140, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item",
                                    modelValue: _ctx.eventData.registrationDeadline,
                                    "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.eventData.registrationDeadline) = $event)),
                                    type: "date",
                                    label: "Sidste tilmeldingsfrist *",
                                    bordered: ""
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_141, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item",
                                    modelValue: _ctx.eventData.eventStart,
                                    "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.eventData.eventStart) = $event)),
                                    type: "datetime-local",
                                    label: "Starttidspunkt",
                                    rules: [(eventStart) => _ctx.eventData.eventStart.length > 1 || 'Der mangler angivelse af en tidspunkt'],
                                    placeholder: "Dato",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_142, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item",
                                    modelValue: _ctx.eventData.eventEnd,
                                    "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.eventData.eventEnd) = $event)),
                                    type: "datetime-local",
                                    label: "Sluttidspunkt",
                                    rules: [(eventEnd) => _ctx.eventData.eventEnd.length > 1 || 'Der mangler angivelse af et tidspunkt'],
                                    placeholder: "Dato",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_143, [
                                _createElementVNode("div", _hoisted_144, [
                                  _createVNode(_component_va_select, {
                                    class: "mb-4 item",
                                    label: "Arrangørklub",
                                    modelValue: _ctx.eventClubsNameValue,
                                    "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.eventClubsNameValue) = $event)),
                                    options: _ctx.eventClubsNameOptions,
                                    "text-by": "name",
                                    searchable: "",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "options"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_145, [
                                _createElementVNode("div", _hoisted_146, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4",
                                    modelValue: _ctx.eventData.extraContactTelephone,
                                    "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.eventData.extraContactTelephone) = $event)),
                                    type: "text",
                                    label: "Tilmelding Telefonnummer **",
                                    bordered: ""
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_147, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4",
                                    modelValue: _ctx.eventData.extraContactEmail,
                                    "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.eventData.extraContactEmail) = $event)),
                                    type: "text",
                                    label: "Tilmelding Email **",
                                    bordered: ""
                                  }, null, 8, ["modelValue"])
                                ])
                              ]),
                              _hoisted_148,
                              _hoisted_149
                            ])
                          ]),
                          _: 1
                        }, 8, ["onSubmit"])
                      ]),
                      _createElementVNode("div", _hoisted_150, [
                        _createElementVNode("div", _hoisted_151, [
                          _createVNode(_component_va_button, {
                            class: "btn",
                            color: "success",
                            size: "large",
                            onClick: _cache[75] || (_cache[75] = ($event: any) => {_ctx.$refs.form.validate(); _ctx.createEvent()})
                          }, {
                            default: _withCtx(() => [
                              _hoisted_152
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.addInvitationToNewEventModal,
          "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.addInvitationToNewEventModal) = $event)),
          size: "large",
          "overlay-opacity": "0.5",
          "hide-default-actions": "",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "mr-4",
              color: "success",
              onClick: _cache[79] || (_cache[79] = ($event: any) => (_ctx.useSelectedInvitation('create')))
            }, {
              default: _withCtx(() => [
                _hoisted_160
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              color: "secondary",
              onClick: _cache[80] || (_cache[80] = ($event: any) => (_ctx.cancelAddInvitation('create')))
            }, {
              default: _withCtx(() => [
                _hoisted_161
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_153, [
              _createElementVNode("div", _hoisted_154, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medias, (media, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "invitationcontainer",
                    key: media.id
                  }, [
                    _createElementVNode("label", _hoisted_155, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.selectedEventInvitation) = $event)),
                        type: "radio",
                        color: "success",
                        id: index,
                        name: "choosenInvitation",
                        value: media
                      }, null, 8, _hoisted_156), [
                        [_vModelRadio, _ctx.selectedEventInvitation]
                      ]),
                      _createTextVNode(" " + _toDisplayString(' ' + media.name), 1)
                    ])
                  ]))
                }), 128))
              ]),
              _createVNode(_component_va_divider),
              _hoisted_157,
              _createElementVNode("div", _hoisted_158, [
                _createElementVNode("input", {
                  class: "mb-4",
                  type: "file",
                  onChange: _cache[77] || (_cache[77] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
                }, null, 32),
                _createVNode(_component_va_button, {
                  class: "btn",
                  onClick: _cache[78] || (_cache[78] = ($event: any) => (_ctx.onUpload()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_159
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Opret nyt arrangement']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_162, [
        _createElementVNode("div", _hoisted_163, [
          _hoisted_164,
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_165, _toDisplayString(_ctx.error), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_166, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventtypes, (eventtype) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "eventype_card",
                    key: eventtype.id
                  }, [
                    _createElementVNode("h5", {
                      class: "display-5 eventtype_titel",
                      id: 'eventtypestable-row' + (_ctx.index+1)
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(eventtype.event_type_titel), 1)
                    ], 8, _hoisted_167),
                    _createElementVNode("p", {
                      class: "eventtype_description",
                      id: 'eventtypestable-row' + (_ctx.index+1)
                    }, [
                      _hoisted_169,
                      _createTextVNode(" " + _toDisplayString(eventtype?.event_type_beskrivelse?.trim().slice(0, 100) + (eventtype?.event_type_beskrivelse?.trim()?.length > 101 ? ' ...' : '')), 1)
                    ], 8, _hoisted_168),
                    _createElementVNode("div", {
                      class: "eventtype_buttons",
                      id: 'eventtypestable-row' + (_ctx.index+1)
                    }, [
                      _createVNode(_component_va_divider),
                      (eventtype.event_type_titel?.trim().toLowerCase() !== 'ukendt arrangement-type')
                        ? (_openBlock(), _createBlock(_component_va_button_group, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_va_button, {
                                class: "btn",
                                color: "info",
                                rounded: false,
                                name: "editeventtype",
                                onClick: ($event: any) => (_ctx.editEventType(eventtype.id, eventtype.documentId))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_171
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_va_button, {
                                class: "btn status-width",
                                icon: eventtype.event_type_status ? 'check_box' : 'check_box_outline_blank',
                                color: eventtype.event_type_status ? 'success' : 'rgb(255, 172, 10)',
                                name: "statusEventType",
                                onClick: ($event: any) => (_ctx.statusEventType(eventtype.id, eventtype.documentId))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(eventtype.event_type_status ? 'Aktiv' : 'Inaktiv'), 1)
                                ]),
                                _: 2
                              }, 1032, ["icon", "color", "onClick"]),
                              _createVNode(_component_va_button, {
                                class: "btn",
                                color: "danger",
                                rounded: false,
                                name: "deleteeventtype",
                                onClick: ($event: any) => (_ctx.deleteEventTypeWarning(eventtype.id, eventtype.documentId, eventtype.event_type_titel))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_172
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_170)
                  ]))
                }), 128))
              ]))
        ]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.deleteEventTypeWarningModal,
          "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.deleteEventTypeWarningModal) = $event)),
          "hide-default-actions": "",
          "overlay-opacity": "0.5"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn deletebuttonmargin",
              color: "danger",
              onClick: _cache[82] || (_cache[82] = ($event: any) => (_ctx.deleteEventType(this.deleteEventTypeId, this.deleteEventTypeDocumentId, this.deleteEventTypeTitel), _ctx.$Message.success({ text: 'Arrangement-typen er blevet slettet' })))
            }, {
              default: _withCtx(() => [
                _hoisted_174
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn deletebuttonmargin",
              color: "secondary",
              onClick: _cache[83] || (_cache[83] = ($event: any) => (_ctx.deleteEventTypeWarningModal = false, _ctx.$Message.warning({ text: 'Annulleret' })))
            }, {
              default: _withCtx(() => [
                _hoisted_175
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_173
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editEventTypeModal,
          "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => ((_ctx.editEventTypeModal) = $event)),
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "success",
              onClick: _cache[87] || (_cache[87] = ($event: any) => (_ctx.updateEventType() ? _ctx.$Message.success({ text: 'Gemt succesfuldt' }) : _ctx.$Message.danger({ text: 'Fejl i et felts værdi' })))
            }, {
              default: _withCtx(() => [
                _hoisted_182
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "secondary",
              onClick: _cache[88] || (_cache[88] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), (_ctx.editEventTypeModal = false), _ctx.cancelEventTypeEdit()))
            }, {
              default: _withCtx(() => [
                _hoisted_183
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_176, [
              _hoisted_177,
              _createElementVNode("div", _hoisted_178, [
                _createElementVNode("div", _hoisted_179, [
                  _createVNode(_component_va_input, {
                    class: "mb-4",
                    type: "text",
                    modelValue: _ctx.eventTypeData.eventTypeTitel,
                    "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => ((_ctx.eventTypeData.eventTypeTitel) = $event)),
                    label: "Typens titel",
                    placeholder: "Titeltekst",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_180, [
                _createElementVNode("div", _hoisted_181, [
                  _createVNode(_component_va_input, {
                    class: "mb-4",
                    type: "textarea",
                    modelValue: _ctx.eventTypeData.eventTypeDescription,
                    "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.eventTypeData.eventTypeDescription) = $event)),
                    label: "Typens beskrivelse",
                    placeholder: "Tekst",
                    "min-rows": 8,
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis og rediger arrangement-typer']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_184, [
        _createElementVNode("div", _hoisted_185, [
          _hoisted_186,
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_187, _toDisplayString(_ctx.error), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_188, [
                (!_ctx.submitted2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_189, [
                      _createElementVNode("div", _hoisted_190, [
                        _createVNode(_component_va_form, {
                          ref: "form",
                          id: "neweventtypeform",
                          onSubmit: _ctx.handleSubmit
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_191, [
                              _createElementVNode("div", _hoisted_192, [
                                _createElementVNode("div", _hoisted_193, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item",
                                    modelValue: _ctx.eventTypeData.eventTypeTitel,
                                    "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => ((_ctx.eventTypeData.eventTypeTitel) = $event)),
                                    type: "text",
                                    label: "Typens titel",
                                    rules: [(eventTypeTitel) => _ctx.eventTypeData.eventTypeTitel.length > 1 || 'Der mangler en titel'],
                                    placeholder: "Titeltekst",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_194, [
                                _createElementVNode("div", _hoisted_195, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item",
                                    type: "textarea",
                                    modelValue: _ctx.eventTypeData.eventTypeDescription,
                                    "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => ((_ctx.eventTypeData.eventTypeDescription) = $event)),
                                    label: "Typens beskrivelse",
                                    rules: [(eventTypeDescription) => _ctx.eventTypeData.eventTypeDescription.length > 1 || 'Der mangler en beskrivelse'],
                                    placeholder: "Tekst",
                                    "min-rows": 8,
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["onSubmit"])
                      ]),
                      _createElementVNode("div", _hoisted_196, [
                        _createElementVNode("div", _hoisted_197, [
                          _createVNode(_component_va_button, {
                            class: "btn",
                            color: "success",
                            size: "large",
                            onClick: _cache[92] || (_cache[92] = ($event: any) => {_ctx.$refs.form.validate(); _ctx.createEventType()})
                          }, {
                            default: _withCtx(() => [
                              _hoisted_198
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Opret ny arrangement-type']
      ])
    ])
  ]))
}